// extracted by mini-css-extract-plugin
module.exports = {"root":"ControlBtn_root__1ABwI","large":"ControlBtn_large___vmsm","medium":"ControlBtn_medium__38Wws","small":"ControlBtn_small__1W1lH","extraSmall":"ControlBtn_extraSmall__2zs5J"};